<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    title="驳回退款/货"
    custom-class="customModal">
    <el-form ref="form" :model="form" :rules="rules" >
      <el-form-item label="拒绝理由:" prop="return_refuse_reason">
        <el-input v-model="form.return_refuse_reason"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';
  export default {
    name: 'confirmRefund',
    data() {
      return {
        visible: false,
        rules: {
          return_refuse_reason: [{ required: true, message: '请填写拒绝理由'}],
        },
        form:{
          return_refuse_reason:'',
          return_check:'2'
        },
        orderData: {},
      }
    },
    methods: {
      open(data) {
        this.visible = true;
        this.orderData = data;
      },
      cancel() {
        this.visible = false;
      },
      async submit(data) {
        if(await this.$refs.form.validate()){
          await OrderService.refundConfirm({return_refuse_reason:this.form.return_refuse_reason,return_check:this.form.return_check , order_id: this.orderData.order_id}).then(()=>{
            this.cancel()
            this.$emit('success')
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>